var map = {
	"./avatar.svg": 19542,
	"./close.svg": 95363,
	"./download-file.svg": 91000,
	"./error.svg": 94041,
	"./folder.svg": 16805,
	"./link.svg": 89797,
	"./location.svg": 1028,
	"./module.svg": 6445,
	"./organization.svg": 53028,
	"./pause.svg": 72729,
	"./price.svg": 53884,
	"./trend.svg": 19126,
	"./user.svg": 27728,
	"./wave.svg": 35902,
	"./workorder.svg": 72194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2048;